var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConnectors(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 70 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.53 8.513H12.47a3.973 3.973 0 0 0-3.97 3.968v45.038a3.973 3.973 0 0 0 3.969 3.968H57.53a3.973 3.973 0 0 0 3.97-3.968V12.481a3.973 3.973 0 0 0-3.97-3.968Zm-21.53 2h21.53a1.971 1.971 0 0 1 1.97 1.968v21.51h-6.93a1 1 0 0 0-1 1 3.82 3.82 0 1 1-7.64 0 1 1 0 0 0-1-1H36v-6a5.821 5.821 0 0 0 0-11.468Zm-23.532 0H34v6.927a1 1 0 0 0 1 1 3.82 3.82 0 1 1 0 7.64 1 1 0 0 0-1 1v6.911h-6.016a5.821 5.821 0 0 0-11.468 0H10.5v-21.51a1.971 1.971 0 0 1 1.97-1.968ZM34 59.487H12.47a1.971 1.971 0 0 1-1.97-1.968v-21.51h6.93a1 1 0 0 0 1-1 3.82 3.82 0 1 1 7.64 0 1 1 0 0 0 1 1H34v6a5.82 5.82 0 0 0 0 11.468Zm23.532 0H36V52.56a1 1 0 0 0-1-1 3.82 3.82 0 1 1 0-7.64 1 1 0 0 0 1-1v-6.911h6.014a5.821 5.821 0 0 0 11.468 0H59.5v21.51a1.971 1.971 0 0 1-1.97 1.968Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectors);
export default __webpack_public_path__ + "static/media/connectors.d351194cc142c3fd8264176f209d6b31.svg";
export { ForwardRef as ReactComponent };